import { render } from "./CrudForm.vue?vue&type=template&id=4a2e3d77&scoped=true"
import script from "./CrudForm.vue?vue&type=script&lang=js"
export * from "./CrudForm.vue?vue&type=script&lang=js"

import "./CrudForm.vue?vue&type=style&index=0&id=4a2e3d77&scoped=true&lang=css"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2e3d77"]])

export default __exports__